import styled from '@emotion/styled';

export const SelectPartMessage = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 20px;
  height: 120px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.tertiary};

  p {
    margin: 0;
  }
`;

export const ReturnLink = styled.a`
  color: ${({ theme }) => theme.colors.secondary};
`;
